<template>
  <div class="homeBody">
    <el-container class="container">
      <el-aside >
        <div class="logoBox" v-show="!isShowaside">土地资源管理平台</div>
        <div class="logoBox2" v-show="isShowaside"></div>
        <el-menu
          :collapse="isShowaside"
          default-active="/map"
          class="el-menu-vertical-demo"
          background-color="#314155"
          text-color="#fff"
          active-text-color="#42A0FD"
          :router="true"
        >
          <el-menu-item index="/map" >
            <i class="el-icon-s-order"></i>
            <span slot="title">地图管理</span>
          </el-menu-item>
          <el-menu-item index="/laryer" >
            <i class="el-icon-s-marketing"></i>
            <span slot="title">图层管理</span>
          </el-menu-item>
          <el-menu-item index="/personnel">
            <i class="el-icon-user-solid"></i>
            <span slot="title">人员管理</span>
          </el-menu-item>
          <el-menu-item index="/Land">
            <i class="el-icon-menu"></i>
            <span slot="title">土地管理</span>
          </el-menu-item>
          <el-menu-item index="/institution">
            <i class="el-icon-s-shop"></i>
            <span slot="title">机构管理</span>
          </el-menu-item>
        </el-menu>
      </el-aside>
      <el-container>
        <el-header>
          <div class="eixtBox" @click="changeisShowaside">
            <i class="el-icon-s-fold" v-show="!isShowaside"></i>
            <i class="el-icon-s-unfold" v-show="isShowaside"></i>
          </div>
          <div class="userInfoBox">
            <i class="el-icon-user-solid"></i>
            <div class="unserName">管理员</div>
            <el-button
              style=" margin-left: 15px;"
              type="primary"
              size="mini"
              icon="el-icon-s-tools"
              @click="goToLoginPage"
            >退出登录</el-button>
          </div>
        </el-header>
        <el-main>
          <router-view class="myviewBody"></router-view>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isShowaside: false
    };
  },
  methods:{
    changeisShowaside(){
      this.isShowaside = !this.isShowaside
    },
    goToLoginPage(){
      this.$router.push("/login")
    }
  }
};
</script>

<style>
.logoBox2{
  height: 60px;

}
.homeBody {
  height: 100vh;
  width: 100vw;
  /* background-color: antiquewhite; */
}
.el-aside {
  background-color: #314156;
  width: auto !important;
  /* color: #333; */
  /* text-align: center; */
  /* line-height: 200px; */
}
.el-container {
  width: 100%;
  height: 100%;
}
.el-header {
  width: 100%;
  padding: 0 !important;
  display: flex;
  justify-content: space-between;
  border-bottom: 3px #314156 solid;
 
}
#app .el-main {
  height: 100%;
  width: 100%;
  /* background-color: antiquewhite; */
  padding: 0;
}
.myviewBody {
  height: 100%;
  width: 100%;
}

.logoBox {
  height: 60px;
  width: 200px;
  line-height: 60px;
  color: white;
  text-align: center;
}
.userInfoBox {
  height: 60px;
  width: 230px;
  /* float: right; */
  font-size: 25px;
  display: flex;
  align-items: center;
  padding-right:15px
}
.unserName {
  height: 60px;
  width: 100px;
  line-height: 60px;
  font-size: 15px;
  /* background-color:red; */
  margin-left: 15px;
}
.eixtBox {
  height: 60px;
  width: 60px;
  /* background-color: aqua; */
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 25px;
}
/* .leaflet-default-icon-path {
	background-image: url(https://cdn.jsdelivr.net/npm/leaflet@1.7.1/dist/images/marker-icon.png);
} */
</style>